import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { MessageCircleQuestion } from "lucide-react";

interface InfoSectionProps {
  title: string;
  children: ReactNode;
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
  tooltip?: string;
}

export function InfoSection({
  title,
  children,
  className,
  titleClassName,
  contentClassName,
  tooltip,
}: InfoSectionProps) {
  return (
    <div className={cn("space-y-3", className)}>
      <div className="flex items-center gap-2">
        <h3 className={cn("text-lg font-semibold", titleClassName)}>{title}</h3>

        {tooltip && (
          <Popover>
            <PopoverTrigger asChild>
              <MessageCircleQuestion className="w-4 h-4 self-start cursor-pointer" />
            </PopoverTrigger>
            <PopoverContent className="w-auto max-w-[260px] p-3">
              <p className="text-sm">{tooltip}</p>
            </PopoverContent>
          </Popover>
        )}
      </div>

      <div className={cn("space-y-2", contentClassName)}>{children}</div>
    </div>
  );
}
